import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { pt} from '../../../../components/utiles';

export default class Indicator extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        const {
            totalCount,
            activeIndex,
            containerStyle,
            itemStyle,
            itemActiveStyle
        } = this.props;
        return (
            <View style={[st.indicators, containerStyle]}>
                {
                    new Array(totalCount).fill('').map((item, index) => {
                        return <View key={index} style={[st.indicator, itemStyle, index === activeIndex ? st.activeIndicator : null, index === activeIndex ? itemActiveStyle : null]} />;
                    })
                }
            </View>
        );
    }
}

const st = StyleSheet.create({
    indicators: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    indicator: {
        width: pt(16),
        height: pt(6),
        backgroundColor: '#F2F2F2',
        borderRadius: pt(4),
        marginHorizontal: pt(2)
    },
    activeIndicator: {
        width: pt(28),
        backgroundColor: '#C71622'
    }
});
